"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locator = void 0;
var json_schema_validator_1 = require("@catalytic/json-schema-validator");
var view_1 = require("@catalytic/view");
var WORD = /[a-zA-Z0-9._%+-]/;
function locator(value, fromIndex) {
    var position = value.indexOf('@', fromIndex);
    if (!fromIndex)
        return position;
    var prevChar = value.substr(fromIndex - 1, 1);
    if (!prevChar)
        return position;
    return !WORD.test(prevChar) ? position : -1;
}
exports.locator = locator;
function mention(eat, value, silent) {
    var _a;
    var match = /^@([a-z][a-z0-9-_]+)/.exec(value);
    if (match) {
        if (silent) {
            return true;
        }
        return eat(match[0])(view_1.referenceView({ role: ((_a = this.options) === null || _a === void 0 ? void 0 : _a.role) || view_1.Role.READER, refType: json_schema_validator_1.JSONRefType.ACTOR }, match[1]));
    }
}
exports.default = mention;
mention.locator = locator;
mention.notInLink = false;
//# sourceMappingURL=mention.js.map